// App header component with KayQ branding - 68 lines ✅
import { Link } from 'react-router-dom'
import { Menu, User, LogOut, Settings } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/hooks/useAuth'

interface HeaderProps {
  onMenuClick: () => void
}

export function Header({ onMenuClick }: HeaderProps): JSX.Element {
  const { user, organization, signOut } = useAuth()

  return (
    <header className="sticky top-0 z-50 w-full border-b border-kaycoo-white-3 bg-kaycoo-teal-dark text-white backdrop-blur">
      <div className="container flex h-14 items-center">
        <Button
          variant="ghost"
          size="icon"
          className="mr-2 text-white hover:bg-kaycoo-teal-dark-2 md:hidden"
          onClick={onMenuClick}
          aria-label="Toggle menu"
        >
          <Menu className="h-5 w-5" />
        </Button>

        <div className="flex flex-1 items-center justify-between space-x-2">
          <Link to="/dashboard" className="flex items-center space-x-2 hover:opacity-90">
            <span className="inline-block font-bold text-white">D365 AI Assistant</span>
          </Link>

          <div className="flex items-center gap-2">
            {organization && (
              <div className="hidden text-sm text-kaycoo-teal-light sm:block">
                {organization.name}
              </div>
            )}

            <Link to="/settings">
              <Button variant="ghost" size="icon" className="text-white hover:bg-kaycoo-teal-dark-2" aria-label="Settings">
                <Settings className="h-5 w-5" />
              </Button>
            </Link>

            {user && (
              <div className="flex items-center gap-2">
                <div className="hidden flex-col items-end text-sm sm:flex">
                  <span className="font-medium text-white">{user.fullName}</span>
                  <span className="text-xs text-kaycoo-teal-light">{user.role}</span>
                </div>

                {user.avatarUrl ? (
                  <img
                    src={user.avatarUrl}
                    alt={`${user.fullName} avatar`}
                    className="h-8 w-8 rounded-full border-2 border-kaycoo-teal-light"
                  />
                ) : (
                  <div
                    className="flex h-8 w-8 items-center justify-center rounded-full bg-kaycoo-teal-light text-kaycoo-teal-dark"
                    role="img"
                    aria-label={`${user.fullName} avatar`}
                  >
                    <User className="h-4 w-4" />
                  </div>
                )}

                <Button variant="ghost" size="icon" className="text-white hover:bg-kaycoo-teal-dark-2" onClick={signOut} aria-label="Sign out">
                  <LogOut className="h-5 w-5" />
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}
